import { useMemo } from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import map from 'lodash/map';

import accountsResource from 'src/actions/accounts/accountsResource';
import agentsResource from 'src/actions/agent/agentsResource';
import { STATUS_SUCCEEDED, STATUS_LOADING, allSucceeded } from 'src/presentation/hooks/useResource';
import { toDateTimeString } from 'src/presentation/components/pages/shared/utils/TimeUtils';
import { useEndpointsWithInboxes } from './useEndpointsWithInboxes';
import useResource from 'src/presentation/hooks/useResource';

const getAgentName = (agents, item) => {
  const agent = find(agents, agent => agent.id === get(item, 'updatedBy.userId'));

  return get(agent, 'name', '');
};

export const useEndpointsWithInboxesAndAgent = () => {
  const { endpoints, endpointsErrors, loadingState } = useEndpointsWithInboxes();

  const { values: agents = [], loadingState: agentsLoadingState } = useResource(agentsResource);
  const { loadingState: accountsLoadingState } = useResource(accountsResource);

  const endpointsWithAgentInformation = useMemo(() => {
    return map(endpoints, endpoint => ({
      ...endpoint,
      updatedAtString: toDateTimeString(endpoint.updatedAt),
      updatedByString: getAgentName(agents, endpoint),
    }));
  }, [endpoints, agents]);

  const isAllSucceeded = allSucceeded(loadingState, agentsLoadingState, accountsLoadingState);
  const loading = isAllSucceeded ? STATUS_SUCCEEDED : STATUS_LOADING;

  return { endpoints: endpointsWithAgentInformation, endpointsErrors, loadingState: loading };
};
